export const RUNE_PERIODS = ['6h', '1d', '7d', '30d'] as const
export type RunePeriod = typeof RUNE_PERIODS[number]
export type RuneMarket = { id: string; name: string; symbol: string; floorSats: number | null; change: number | null; volumeSats: number; sales: number | null; marketCapBtc: number | null; updatedAt: number | null; owSlug?: string }
export type RuneSnapshot = { markets: RuneMarket[]; period: RunePeriod; fetchedAt: number; source: 'Satflow' }
const finite = (value: unknown): number | null => value === null || value === undefined || value === '' || !Number.isFinite(Number(value)) ? null : Number(value)
export function normalizeRuneMarkets(rows: unknown, period: RunePeriod): RuneMarket[] {
 if (!Array.isArray(rows)) throw new Error('Invalid Rune market response')
 const markets = new Map<string, RuneMarket>()
 for (const row of rows) {
  if (row?.metaType !== 'runes' || typeof row.slug !== 'string' || !/^[A-Z•]+$/.test(row.slug)) continue
  const id = row.metadata?.id
  const volume = finite(row[`volume${period}`])
  if (typeof id !== 'string' || !/^\d+:\d+$/.test(id) || volume === null || volume < 0) continue
  const floor = finite(row.floorPrice)
  const cap = finite(row.marketCap)
  const sales = finite(row[`sales${period}`])
  markets.set(id, { id, name: row.slug, symbol: String(row.metadata?.entry?.symbol || 'ᚱ'), floorSats: floor !== null && floor > 0 ? floor : null, change: finite(row[`floor${period}ChangePercent`]), volumeSats: volume, sales: sales !== null && sales >= 0 ? sales : null, marketCapBtc: cap !== null && cap > 0 ? cap : null, updatedAt: finite(row.statisticsUpdatedAt) })
 }
 return [...markets.values()].sort((a,b)=>b.volumeSats-a.volumeSats).slice(0,10)
}
